import { generatePath } from 'react-router'

export const endpoints = {
    inclusionScoresSkeleton: (uuid: string): string =>
        generatePath('analyze/company/:uuid/inclusion-scores-skeleton/', { uuid }),
}
